/**
 * Between-game court setup — lifecycle helpers (serialized on scoring Match).
 */

/**
 * @param {import('./matchScoring').Match|null|undefined} match
 * @returns {boolean}
 */
export function isAwaitingCourtSetup(match) {
  return Boolean(match?.awaitingNextGame);
}

/**
 * @param {import('./matchScoring').Match|null|undefined} match
 * @returns {null|{ completedGameNumber: number, nextGameNumber: number, title: string, subtitle: string }}
 */
export function resolveCourtSetupPresentation(match) {
  if (!isAwaitingCourtSetup(match) || !match?.games?.length) return null;
  const completedGameNumber = match.games.length;
  const nextGameNumber = completedGameNumber + 1;
  return {
    completedGameNumber,
    nextGameNumber,
    title: `Game ${completedGameNumber} Complete`,
    subtitle: `Preparing Game ${nextGameNumber}`,
    statusLine: "Awaiting Court Setup",
  };
}
